import {all, fork} from 'redux-saga/effects'
import documentTypesSaga from './sagas/document-types';
import expiredManualFormsSaga from './sagas/expired-manual-forms';

export default function* () {
  yield all([
    fork(documentTypesSaga),
    //  fork(expiredManualFormsSaga),
  ])
}
